import React, { Component, Fragment } from 'react';
import { CUSTOM_ATTR_NA } from 'src/util/PrioritizeUtil'
import './Participate.scss';


export class Summary extends Component {
  render() {
    const { title, score } = this.props

    return (
      <div className="summary">
        <h2>{title.toLocaleUpperCase()}</h2>
        <label>{score && score !== 'NaN' ? score : '—'}</label>
      </div>
    )
  }
}

export default class Content extends Component {

  render() {
    const { children, overall, weighted, customAttr1Label, customAttr1Value, noHeader } = this.props

    return (
      <div className='participate__content'>
        {!noHeader && <div className='participate__content-header'>
          <div className='summary_container'>
            <Summary title="overall rating" score={overall} />
            <div className="vertical_divider" />
            <Summary title="weighted score" score={weighted} />
            { customAttr1Label && customAttr1Label !== CUSTOM_ATTR_NA &&
            <Fragment>
              <div className="vertical_divider" />
              <Summary title={customAttr1Label} score={customAttr1Value} />
            </Fragment>
            }
          </div>
        </div>}
        {children}
      </div>
    )
  }
}

